export default __webpack_public_path__ + "static/media/AssignmentIcon.da4ed78c.svg";